import { Theme } from 'theme-ui'

const cards: Theme['cards'] = {
  primary: {
    bg: 'elevated',
    color: 'text',
    p: [3, 4],
    borderRadius: 'extra',
    boxShadow: 'card',
    overflow: 'hidden',
  },
}

export default cards
